import { isZIndexToken } from '@smoothie-framework/ui-core/tokens';
import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier } from './utility-value-syntax';
const INTEGER_VALUE_PATTERN = /^-?(?:0|[1-9]\d*)$/;
function isSupportedKeyword(value) {
    return value === 'auto' || isCssWideKeyword(value);
}
export function classifyZIndexUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue === 'number') {
        const normalizedValue = String(rawValue);
        return Number.isInteger(rawValue)
            ? { valid: true, kind: 'numeric', normalizedValue }
            : { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (INTEGER_VALUE_PATTERN.test(normalizedValue)) {
        return { valid: true, kind: 'numeric', normalizedValue };
    }
    if (isZIndexToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (!isSupportedKeyword(normalizedValue)) {
            return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
        }
        return { valid: true, kind: 'keyword', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=z-index-values.js.map